const initNavLinkSelector = () => {
    //arrays
    const buttonsNavLinkArray = document.querySelectorAll(".navbar .item");
    const removeSelectedButtons = (arrayOfButtons) => {
        arrayOfButtons.forEach(function (singleButton) {
            singleButton.classList.remove("selected");
        });
    };
    buttonsNavLinkArray.forEach(function (singleLink) {
        singleLink.addEventListener('click', function () {
            removeSelectedButtons(buttonsNavLinkArray);
            singleLink.classList.add("selected");
        });
    });
};
